import { QueryClient, useMutation, useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ORGANIZATION_BRANDING_API_URL, ORGANIZATION_BRANDING_BY_ID_QUERY_KEY } from '@/constants';
import { apiUrl } from '@/helpers';
import {
  ErrorResponse,
  OrganizationBranding,
  OrganizationLogoSasTokenPayload,
  Options
} from '@/types';

export const OrganizationBrandingEndpoints = {
  getByOrganizationId: (organizationId: number) =>
    axios.get(`${apiUrl()}${ORGANIZATION_BRANDING_API_URL}/${organizationId}`),
  update: (payload: OrganizationBranding) =>
    axios.patch(`${apiUrl()}${ORGANIZATION_BRANDING_API_URL}`, payload),
  createLogoSasToken: (payload: OrganizationLogoSasTokenPayload) =>
    axios.post(`${apiUrl()}${ORGANIZATION_BRANDING_API_URL}/logo-sas-token`, payload)
};

export const useGetOrganizationBrandingQuery = (organizationId: number, enabled = true) => {
  return useQuery(
    [ORGANIZATION_BRANDING_BY_ID_QUERY_KEY, { organizationId }],
    () => OrganizationBrandingEndpoints.getByOrganizationId(organizationId),
    {
      enabled: !!organizationId && enabled,
      retry: false
    }
  );
};

export const useUpdateOrganizationBrandingMutation = (
  queryClient: QueryClient,
  options: Options
) => {
  return useMutation(OrganizationBrandingEndpoints.update, {
    onSuccess: (response) => {
      options.onSuccess(response);
      queryClient.invalidateQueries([ORGANIZATION_BRANDING_BY_ID_QUERY_KEY]);
    },
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};

export const useCreateOrganizationLogoSasTokenMutation = (options: Options) => {
  return useMutation(OrganizationBrandingEndpoints.createLogoSasToken, {
    onSuccess: options.onSuccess,
    onError: (error) => {
      options.onError(error as ErrorResponse);
    }
  });
};
